
import { defineComponent } from 'vue'
// import PatientNotes from './PatientNotes.vue'
import PatientCondition from './PatientCondition.vue'
import PatientMedication from './PatientMedication.vue'
// import PatientHistory from './PatientHistory.vue'
// import NursingWorkflow from './NursingWorkflow.vue'
// import DoctorsWorkflow from './DoctorsWorkflow.vue'
// import ScanArchival from './ScanArchival.vue'
// import CaseNotes from './CaseNotes.vue'
// import SurgicalWorkflow from './SurgicalWorkflow.vue'
// import PatientSearch from '../shared/PatientSearch.vue'
// import PatientSummary from '../shared/PatientSummary.vue'

export default defineComponent({
name: 'MedicalDashboard',
components: { 
    // PatientNotes,
    // CaseNotes,
    // DoctorsWorkflow,
    // NursingWorkflow,
    // PatientHistory,
    PatientMedication,
    PatientCondition,
    // ScanArchival,
    // SurgicalWorkflow,
    // PatientSearch,
    // PatientSummary
},
data: () => ({
    currentItem: 'tab-Notes',
    items: [
        'Notes', 'Medication', 'History', 'Nursing & Workflow',
    ],
    more: [
        'Doctors & Workflow', 'Surgical & Workflow', 'Case Notes', 'Scanning & Archival',
    ],
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    searchPatient: false,
    patient: null
    }),
methods: {
    addItem (item: string) {
    const removed = this.items.splice(0, 1)
    this.items.push(
        ...this.more.splice(this.more.indexOf(item), 1),
    )
    this.more.push(...removed)
    this.$nextTick(() => { this.currentItem = 'tab-' + item })
    },
    onSearch() {
    this.searchPatient = true
    this.patient = null
    },
    selectedPatient(selectedPatient) {
    this.patient = selectedPatient
    this.searchPatient = false
    }
},
mounted() {
    this.searchPatient = true
    this.patient = null   
}
})
